"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _RegisterForm = require("./RegisterForm");

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _LoginForm = require("./LoginForm");

var _LoginForm2 = _interopRequireDefault(_LoginForm);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginSignupPage = function LoginSignupPage(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$LoginForm = _ref.LoginForm,
      LoginForm = _ref$LoginForm === undefined ? _LoginForm2.default : _ref$LoginForm,
      _ref$RegisterForm = _ref.RegisterForm,
      RegisterForm = _ref$RegisterForm === undefined ? _RegisterForm2.default : _ref$RegisterForm;
  return _react2.default.createElement(
    "div",
    { className: "content", role: "main" },
    _react2.default.createElement(
      "div",
      { id: "login" },
      _react2.default.createElement(
        "div",
        { className: "split-panel" },
        _react2.default.createElement(
          "div",
          { className: "split-panel-section split-panel-divider" },
          _react2.default.createElement(
            "h4",
            { className: "modal-title" },
            "create a new account"
          ),
          _react2.default.createElement(RegisterForm, null)
        ),
        _react2.default.createElement(
          "div",
          { className: "split-panel-section" },
          _react2.default.createElement(
            "h4",
            { className: "modal-title" },
            "log in"
          ),
          _react2.default.createElement(LoginForm, null)
        )
      )
    )
  );
};

exports.default = LoginSignupPage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/LoginSignupPage.js
// module id = 737
// module chunks = 0